import axios from "axios.js";
import axiosLib from "axios";

const handleRequestError = (error) => {
  if (axiosLib.isCancel(error)) {
    return Promise.reject(error);
  }
  return Promise.reject(error);
};

function CRUDactions(key) {
  const keyUp = key.toUpperCase();
  const out = {};
  out["SET_" + keyUp + "S"] = `[${keyUp} APP] SET_${keyUp}S`;
  out["SET_" + keyUp] = `[${keyUp} APP] SET_${keyUp}`;
  out["ADD_" + keyUp] = `[${keyUp} APP] ADD_${keyUp}`;
  out["DELETE_" + keyUp] = `[${keyUp} APP] DELETE_${keyUp}`;

  //QUERY ALL
  out[`get${key}s`] = (config = {}) => {
    const request = axios.get("/" + key, config);
    return (dispatch) =>
      request
        .then((response) => {
          // Response shapes differ across endpoints. Prefer response.data.data
          // when present (API conventions), otherwise fall back to response.data
          // or the full response.
          const payload =
            response && response.data
              ? response.data.data !== undefined
                ? response.data.data
                : response.data
              : response;
          return dispatch({
            type: out["SET_" + keyUp + "S"],
            payload,
          });
        })
        .catch(handleRequestError);
  };

  //QUERY BY ID
  out[`get${key}`] = (id, config = {}) => {
    if (id !== undefined && id !== "new") {
      const request = axios.get(`/${key}/${id}`, config);
      return (dispatch) =>
        request
          .then((response) => {
            const payload = response && response.data ? response.data : response;
            return dispatch({
              type: out["SET_" + keyUp],
              payload,
            });
          })
          .catch(handleRequestError);
    } else {
      return (dispatch) => {
        dispatch({
          type: out["SET_" + keyUp],
          payload: null,
        });
        return Promise.resolve();
      };
    }
  };

  //CREATE
  out[`create${key}`] = (body, config = {}) => {
    const request = axios.post("/" + key, body, config);
    return (dispatch) =>
      request
        .then((response) => {
          const payload = response && response.data ? response.data : response;
          return dispatch({
            type: out["ADD_" + keyUp],
            payload,
          });
        })
        .catch(handleRequestError);
  };

  //EDIT
  out[`set${key}`] = (id, body, config = {}) => {
    const request = axios.put(`/${key}/${id}`, body, config);
    return (dispatch) =>
      request
        .then((response) => {
          const payload = response && response.data ? response.data : response;
          return dispatch({
            type: out["SET_" + keyUp],
            payload,
          });
        })
        .catch(handleRequestError);
  };

  //DELETE
  out[`delete${key}`] = (id, config = {}) => {
    const request = axios.delete(`/${key}/${id}`, config);
    return (dispatch) =>
      request
        .then((response) =>
          dispatch({
            type: out["DELETE_" + keyUp],
            payload: id,
          })
        )
        .catch(handleRequestError);
  };
  return out;
}
const client = CRUDactions("Client");
const appartement = CRUDactions("Appartement");
const locataire = CRUDactions("Locataire");
const mission = CRUDactions("Mission");
const dossier = CRUDactions("Dossier");
const variable = CRUDactions("Variable");
const quitance = CRUDactions("Quitance");
const accompte = CRUDactions("Accompte");
const intendance = CRUDactions("Intendance");
const equipement = CRUDactions("Equipement");
const image = CRUDactions("Image");
const caution = CRUDactions("Caution");
const etatLieux = CRUDactions("EtatLieux");
const fichier = CRUDactions("Fichier");
const user = CRUDactions("User");
export default {
  ...client,
  ...appartement,
  ...locataire,
  ...mission,
  ...dossier,
  ...variable,
  ...quitance,
  ...accompte,
  ...intendance,
  ...equipement,
  ...image,
  ...caution,
  ...etatLieux,
  ...fichier,
  ...user,
};
